// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificaciones .registros-pendientes,
.notificaciones .solicitudes-cita
{ width: 48%; max-width: 600px;}

.notificaciones .tarjeta-pendiente{
    border: 1px solid #007932;
    border-left: 20px solid #007932;
    border-radius: 20px;
    margin: 12px 0;
    padding: 20px 25px 20px 25px;
    gap: 3px;
}

.notificaciones .tarjeta-pendiente button{ padding: 7.5px 16px; }

.notificaciones .tarjeta-pendiente button.rojo{
    border: 2px solid #8E151D;
    color: #8E151D;
}

.notificaciones .tarjeta-pendiente button.rojo:hover{
    background-color:  #8E151D;
    color: #fff;
}

.mensaje-exito {
    border: 1px solid #2ecc71;
    background-color: #eafaf1;
}

.mensaje-notificacion {
    border-radius: 8px;
    font-weight: bold;
    padding: 20px;
    width: 32%;
}

.mensaje-exito.rojo{
    border: 1px solid #8E151D;
    background-color: #e2979c;
    color: #8E151D;
}

.mensaje-exito.rojo p{ color: #8E151D; }

.notificaciones .tarjeta-pendiente textarea{ 
    border: 1px solid black;
    padding: 7.5px 12px;
    border-radius: 10px;
}

.notificaciones .tarjeta-pendiente textarea::placeholder{ 
    color: black; 
    font-weight: 500; 
}

/* Modal con diseño coherente a las tarjetas - MÁXIMA ESPECIFICIDAD */
body .notificaciones div.modal {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 9999998 !important;
    margin: 0 !important;
    padding: 20px !important;
    box-sizing: border-box !important;
}

body .notificaciones div.modal div.modal-content {
    background: white !important;
    border: 1px solid #007932 !important;
    border-radius: 20px !important;
    padding: 25px 30px !important;
    min-width: 450px !important;
    max-width: 600px !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 0 !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
    position: relative !important;
    box-shadow: 0 8px 32px rgba(0, 121, 50, 0.2) !important;
    margin: 0 !important;
}

body .notificaciones div.modal div.modal-content h3 {
    text-align: center !important;
    margin: 0 0 25px 0 !important;
    color: #007932 !important;
    font-size: 20px !important;
    font-weight: bold !important;
    text-transform: uppercase !important;
}

body .notificaciones div.modal div.modal-content div.campo {
    margin-bottom: 20px !important;
}

body .notificaciones div.modal div.modal-content label {
    display: block !important;
    margin-bottom: 8px !important;
    font-weight: bold !important;
    color: #333 !important;
    font-size: 14px !important;
}

body .notificaciones div.modal div.modal-content input[type="date"],
body .notificaciones div.modal div.modal-content input[type="time"] {
    width: 100% !important;
    border: 1px solid #333 !important;
    border-radius: 10px !important;
    padding: 10px 12px !important;
    font-size: 14px !important;
    outline: none !important;
    transition: border-color 0.2s !important;
    border-bottom: 1px solid #333 !important;
}

body .notificaciones div.modal div.modal-content input[type="date"]:focus,
body .notificaciones div.modal div.modal-content input[type="time"]:focus {
    border-color: #007932 !important;
    border: 1px solid #007932 !important;
    border-bottom: 1px solid #007932 !important;
}

body .notificaciones div.modal div.modal-content select {
    width: 100% !important;
    border: 1px solid #333 !important;
    border-radius: 10px !important;
    padding: 10px 12px !important;
    font-size: 14px !important;
    background-color: white !important;
    outline: none !important;
    transition: border-color 0.2s !important;
}

body .notificaciones div.modal div.modal-content select:focus {
    border-color: #007932 !important;
    border: 1px solid #007932 !important;
}

body .notificaciones div.modal div.modal-content textarea {
    width: 100% !important;
    border: 1px solid #333 !important;
    border-radius: 10px !important;
    padding: 10px 12px !important;
    font-size: 14px !important;
    resize: vertical !important;
    min-height: 80px !important;
    outline: none !important;
    font-family: inherit !important;
    transition: border-color 0.2s !important;
}

body .notificaciones div.modal div.modal-content textarea:focus {
    border-color: #007932 !important;
    border: 1px solid #007932 !important;
}

body .notificaciones div.modal div.modal-content textarea::placeholder {
    color: #666 !important;
    font-weight: 400 !important;
}

body .notificaciones div.modal div.botones {
    display: flex !important;
    justify-content: flex-end !important;
    gap: 12px !important;
    margin-top: 25px !important;
    padding-top: 20px !important;
    border-top: 1px solid #eee !important;
}

body .notificaciones div.modal button.boton {
    padding: 8px 20px !important;
    border: 2px solid #007932 !important;
    background-color: white !important;
    color: #007932 !important;
    border-radius: 8px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    transition: all 0.2s !important;
    text-transform: none !important;
    border-bottom: 2px solid #007932 !important;
}

body .notificaciones div.modal button.boton:hover {
    background-color: #007932 !important;
    color: white !important;
}

body .notificaciones div.modal button.boton.verde {
    background-color: #007932 !important;
    color: white !important;
}

body .notificaciones div.modal button.boton.verde:hover {
    background-color: #005a26 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(0, 121, 50, 0.3) !important;
}

.Toastify__toast-container--top-center,
.Toastify__toast-container--top-right{
    top: 40%;
    left: 40%;
    align-items: center;
}

.Toastify__toast{ 
    padding: 25px 35px 25px 25px;
    width: fit-content;
    max-width: 350px;
    line-height: 1.2;
    font-size: 18px;
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Notificaciones.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU,EAAE,gBAAgB,CAAC;;AAE/B;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,QAAQ;AACZ;;AAEA,2CAA2C,mBAAmB,EAAE;;AAEhE;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,uBAAuB,cAAc,EAAE;;AAEvC;IACI,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,qEAAqE;AACrE;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,+CAA+C;IAC/C,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,iBAAiB;IACjB,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,uDAAuD;IACvD,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;;IAEI,sBAAsB;IACtB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,wBAAwB;IACxB,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA;;IAEI,gCAAgC;IAChC,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,kCAAkC;IAClC,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;IACpC,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,kCAAkC;IAClC,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,uDAAuD;AAC3D;;AAEA;;IAEI,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB","sourcesContent":[".notificaciones .registros-pendientes,\n.notificaciones .solicitudes-cita\n{ width: 48%; max-width: 600px;}\n\n.notificaciones .tarjeta-pendiente{\n    border: 1px solid #007932;\n    border-left: 20px solid #007932;\n    border-radius: 20px;\n    margin: 12px 0;\n    padding: 20px 25px 20px 25px;\n    gap: 3px;\n}\n\n.notificaciones .tarjeta-pendiente button{ padding: 7.5px 16px; }\n\n.notificaciones .tarjeta-pendiente button.rojo{\n    border: 2px solid #8E151D;\n    color: #8E151D;\n}\n\n.notificaciones .tarjeta-pendiente button.rojo:hover{\n    background-color:  #8E151D;\n    color: #fff;\n}\n\n.mensaje-exito {\n    border: 1px solid #2ecc71;\n    background-color: #eafaf1;\n}\n\n.mensaje-notificacion {\n    border-radius: 8px;\n    font-weight: bold;\n    padding: 20px;\n    width: 32%;\n}\n\n.mensaje-exito.rojo{\n    border: 1px solid #8E151D;\n    background-color: #e2979c;\n    color: #8E151D;\n}\n\n.mensaje-exito.rojo p{ color: #8E151D; }\n\n.notificaciones .tarjeta-pendiente textarea{ \n    border: 1px solid black;\n    padding: 7.5px 12px;\n    border-radius: 10px;\n}\n\n.notificaciones .tarjeta-pendiente textarea::placeholder{ \n    color: black; \n    font-weight: 500; \n}\n\n/* Modal con diseño coherente a las tarjetas - MÁXIMA ESPECIFICIDAD */\nbody .notificaciones div.modal {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    background-color: rgba(0, 0, 0, 0.6) !important;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    z-index: 9999998 !important;\n    margin: 0 !important;\n    padding: 20px !important;\n    box-sizing: border-box !important;\n}\n\nbody .notificaciones div.modal div.modal-content {\n    background: white !important;\n    border: 1px solid #007932 !important;\n    border-radius: 20px !important;\n    padding: 25px 30px !important;\n    min-width: 450px !important;\n    max-width: 600px !important;\n    width: 100% !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 0 !important;\n    max-height: 90vh !important;\n    overflow-y: auto !important;\n    position: relative !important;\n    box-shadow: 0 8px 32px rgba(0, 121, 50, 0.2) !important;\n    margin: 0 !important;\n}\n\nbody .notificaciones div.modal div.modal-content h3 {\n    text-align: center !important;\n    margin: 0 0 25px 0 !important;\n    color: #007932 !important;\n    font-size: 20px !important;\n    font-weight: bold !important;\n    text-transform: uppercase !important;\n}\n\nbody .notificaciones div.modal div.modal-content div.campo {\n    margin-bottom: 20px !important;\n}\n\nbody .notificaciones div.modal div.modal-content label {\n    display: block !important;\n    margin-bottom: 8px !important;\n    font-weight: bold !important;\n    color: #333 !important;\n    font-size: 14px !important;\n}\n\nbody .notificaciones div.modal div.modal-content input[type=\"date\"],\nbody .notificaciones div.modal div.modal-content input[type=\"time\"] {\n    width: 100% !important;\n    border: 1px solid #333 !important;\n    border-radius: 10px !important;\n    padding: 10px 12px !important;\n    font-size: 14px !important;\n    outline: none !important;\n    transition: border-color 0.2s !important;\n    border-bottom: 1px solid #333 !important;\n}\n\nbody .notificaciones div.modal div.modal-content input[type=\"date\"]:focus,\nbody .notificaciones div.modal div.modal-content input[type=\"time\"]:focus {\n    border-color: #007932 !important;\n    border: 1px solid #007932 !important;\n    border-bottom: 1px solid #007932 !important;\n}\n\nbody .notificaciones div.modal div.modal-content select {\n    width: 100% !important;\n    border: 1px solid #333 !important;\n    border-radius: 10px !important;\n    padding: 10px 12px !important;\n    font-size: 14px !important;\n    background-color: white !important;\n    outline: none !important;\n    transition: border-color 0.2s !important;\n}\n\nbody .notificaciones div.modal div.modal-content select:focus {\n    border-color: #007932 !important;\n    border: 1px solid #007932 !important;\n}\n\nbody .notificaciones div.modal div.modal-content textarea {\n    width: 100% !important;\n    border: 1px solid #333 !important;\n    border-radius: 10px !important;\n    padding: 10px 12px !important;\n    font-size: 14px !important;\n    resize: vertical !important;\n    min-height: 80px !important;\n    outline: none !important;\n    font-family: inherit !important;\n    transition: border-color 0.2s !important;\n}\n\nbody .notificaciones div.modal div.modal-content textarea:focus {\n    border-color: #007932 !important;\n    border: 1px solid #007932 !important;\n}\n\nbody .notificaciones div.modal div.modal-content textarea::placeholder {\n    color: #666 !important;\n    font-weight: 400 !important;\n}\n\nbody .notificaciones div.modal div.botones {\n    display: flex !important;\n    justify-content: flex-end !important;\n    gap: 12px !important;\n    margin-top: 25px !important;\n    padding-top: 20px !important;\n    border-top: 1px solid #eee !important;\n}\n\nbody .notificaciones div.modal button.boton {\n    padding: 8px 20px !important;\n    border: 2px solid #007932 !important;\n    background-color: white !important;\n    color: #007932 !important;\n    border-radius: 8px !important;\n    cursor: pointer !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    transition: all 0.2s !important;\n    text-transform: none !important;\n    border-bottom: 2px solid #007932 !important;\n}\n\nbody .notificaciones div.modal button.boton:hover {\n    background-color: #007932 !important;\n    color: white !important;\n}\n\nbody .notificaciones div.modal button.boton.verde {\n    background-color: #007932 !important;\n    color: white !important;\n}\n\nbody .notificaciones div.modal button.boton.verde:hover {\n    background-color: #005a26 !important;\n    transform: translateY(-1px) !important;\n    box-shadow: 0 4px 12px rgba(0, 121, 50, 0.3) !important;\n}\n\n.Toastify__toast-container--top-center,\n.Toastify__toast-container--top-right{\n    top: 40%;\n    left: 40%;\n    align-items: center;\n}\n\n.Toastify__toast{ \n    padding: 25px 35px 25px 25px;\n    width: fit-content;\n    max-width: 350px;\n    line-height: 1.2;\n    font-size: 18px;\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
